class OrderStateType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'OrderStateType'

export const CANCELED = new OrderStateType(-1, '已取消', 'canceled')
export const OPERATING = new OrderStateType(0, '操作中', 'operating')
export const FINISHED = new OrderStateType(1, '完成', 'finished')

export const ORDER_STATE_TYPES = [CANCELED, OPERATING, FINISHED]
